import * as _moment from 'moment';
_moment.locale('pt-br');
export const Moment = (...args): _moment.Moment => _moment(...args);
